import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import './blog-listing.scss';

const featuredStories = [
  {
    id: 1,
    tag: 'FEATURED STORY',
    title: (
      <>
        Why is <span className="highlight">Ganesh</span>
        <br />
        <span className="highlight">Chaturthi</span> celebrated?
      </>
    ),
    desc: 'Explore the fascinating story, 10 day rituals, regional traditions and the deeper significance behind one of India’s most loved festivals.',
    readTime: '8 min read',
    views: '50k',
    buttonText: 'Read Full Story',
    link: '/blog/anant-chaturdashi-ganesh-visarjan',
    image: '/assets/blog/ganesh-chaturthi-banner.png',
  },
  {
    id: 2,
    tag: 'FEATURED STORY',
    title: (
      <>
        पितृपक्ष में <span className="highlight">कौए को भोजन</span>
        <br />
        <span className="highlight">क्यों खिलाया जाता है?</span>
      </>
    ),
    desc: 'धार्मिक मान्यताओं में कौए को पितरों से जुड़ा हुआ मानते हैं। जानिए पौराणिक कथा, जयंत का प्रसंग और संपूर्ण श्राद्ध पूजा विधि।',
    readTime: '5 min read',
    views: '35k',
    buttonText: 'Read Full Story',
    link: '/blog/pitru-paksha-crow-significance-shradh-puja-vidhi',
    image: '/assets/blog/pitru-paksha-crow-banner.jpg',
  },
  {
    id: 3,
    tag: 'FEATURED STORY',
    title: (
      <>
        माता वैष्णो देवी की <span className="highlight">संपूर्ण कथा:</span>
        <br />
        <span className="highlight">भक्त श्रीधर और भैरवनाथ</span>
      </>
    ),
    desc: 'जानिए भक्त श्रीधर की भक्ति, कन्या रूप में माता का आगमन, बाण गंगा, अर्धकुंवारी गर्भजून गुफा और भैरवनाथ उद्धार की चमत्कारी कथा।',
    readTime: '6 min read',
    views: '42k',
    buttonText: 'Read Full Story',
    link: '/blog/vaishno-devi-story-shridhar-bhairavnath',
    image: '/assets/banner/vaishno-package-banner.webp',
  },
];

const categories = [
  {
    id: 1,
    title: 'Temple Stories',
    articles: '120+ Articles',
    image: '/assets/blog/categories/temple-stories.webp',
    link: '#all-blogs',
  },
  {
    id: 2,
    title: 'Mythology & Legends',
    articles: '95+ Articles',
    image: '/assets/blog/categories/mythology-legends.png',
    link: '#all-blogs',
  },
  {
    id: 3,
    title: 'Pilgrimage Guides',
    articles: '80+ Articles',
    image: '/assets/blog/categories/pilgrimage-guides.webp',
    link: '#all-blogs',
  },
  {
    id: 4,
    title: 'Festivals & Rituals',
    articles: '65+ Articles',
    image: '/assets/blog/categories/festivals-rituals.png',
    link: '#all-blogs',
  },
  {
    id: 5,
    title: 'Hidden Mysteries',
    articles: '50+ Articles',
    image: '/assets/blog/categories/hidden-mysteries.png',
    link: '#all-blogs',
  },
  {
    id: 6,
    title: 'Deities & Devotion',
    articles: '70+ Articles',
    image: '/assets/blog/categories/deities-devotion.png',
    link: '#all-blogs',
  },
];

const allBlogsData = [
  {
    id: 1,
    title: 'Why is Ganesh Chaturthi celebrated?',
    desc: 'Explore the fascinating story, 10 day rituals, regional traditions and the deeper significance behind one of India’s most loved festivals.',
    image: '/assets/blog/ganesh-chaturthi-banner.webp',
    badge: 'TRENDING',
    readTime: '8 min read',
    views: '50k',
    link: '/blog/anant-chaturdashi-ganesh-visarjan',
  },
  {
    id: 2,
    title: 'केदारनाथ मंदिर: जहाँ धरती में समा गए थे भगवान शिव!',
    desc: 'जानिए केदारनाथ मंदिर का प्राचीन इतिहास, महाभारत के बाद पांडवों से जुड़ी पौराणिक कथा और पंच केदार का रहस्य।',
    image: '/assets/blog/trending/kedarnath.webp',
    badge: 'POPULAR',
    readTime: '6 min read',
    views: '45k',
    link: '/blog/kedarnath-temple-history-and-pandava-story',
  },
  {
    id: 3,
    title: 'पितृपक्ष में कौए को भोजन क्यों खिलाया जाता है? जानिए पौराणिक कथा और श्राद्ध पूजा विधि',
    desc: 'धार्मिक मान्यताओं में कौए को पितरों से जुड़ा हुआ मानते हैं। जानिए पितृपक्ष में कौए को भोजन कराने का महत्व, त्रेतायुग की पौराणिक कथा और संपूर्ण श्राद्ध पूजा विधि।',
    image: '/assets/blog/pitru-paksha-crow-banner.jpg',
    badge: 'NEW',
    readTime: '5 min read',
    views: '32k',
    link: '/blog/pitru-paksha-crow-significance-shradh-puja-vidhi',
  },
  {
    id: 4,
    title: 'माता वैष्णो देवी की संपूर्ण कथा: भक्त श्रीधर और भैरवनाथ से जुड़ी अद्भुत कहानी',
    desc: 'जानिए भक्त श्रीधर की भक्ति, कन्या रूप में माता का आगमन, बाण गंगा, अर्धकुंवारी गर्भजून गुफा और भैरवनाथ उद्धार की चमत्कारी कथा।',
    image: '/assets/trending/vaishno-devi.webp',
    badge: 'NEW',
    readTime: '6 min read',
    views: '42k',
    link: '/blog/vaishno-devi-story-shridhar-bhairavnath',
  },
];

const unknownStories = [
  {
    id: 1,
    title: "Why Is Kedarnath's Shivling Different?",
    image: '/assets/blog/stories/kedarnath-shivling.webp',
    readTime: '4 min read',
    link: '/blog/kedarnath-temple-history-and-pandava-story',
  },
  {
    id: 2,
    title: 'Why Does Jagannath Have Such Large Eyes?',
    image: '/assets/blog/stories/jagannath-eyes.webp',
    readTime: '4 min read',
    link: '#',
  },
  {
    id: 3,
    title: 'Why Is Bhairavnath Darshan done after Vaishno Devi?',
    image: '/assets/trending/vaishno-devi.webp',
    readTime: '5 min read',
    link: '/blog/vaishno-devi-story-shridhar-bhairavnath',
  },
  {
    id: 4,
    title: "Did Krishna's Dwarka Really Sink Beneath the Sea?",
    image: '/assets/blog/stories/dwarka-submerged.webp',
    readTime: '6 min read',
    link: '#',
  },
  {
    id: 5,
    title: 'Why Is Kashi Believed to Grant Moksha?',
    image: '/assets/blog/stories/kashi-moksha.webp',
    readTime: '5 min read',
    link: '#',
  },
  {
    id: 6,
    title: "The Secret Behind India's 64 Yogini Temples",
    image: '/assets/blog/stories/yogini-temple.webp',
    readTime: '4 min read',
    link: '#',
  },
];

const faithServices = [
  {
    id: 1,
    name: 'Itineraries',
    link: '/listing',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" />
        <line x1="9" y1="3" x2="9" y2="18" />
        <line x1="15" y1="6" x2="15" y2="21" />
        <circle cx="9" cy="10" r="1.5" fill="currentColor" />
      </svg>
    ),
  },
  {
    id: 2,
    name: (
      <>
        Travel
        <br />
        Booking
      </>
    ),
    link: '/listing',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="6" y="2" width="12" height="20" rx="3" />
        <path d="M9 7h6" />
        <path d="M9 11h6" />
        <path d="M9 15l2 2 4-4" />
      </svg>
    ),
  },
  {
    id: 3,
    name: (
      <>
        Smart
        <br />
        Locker
      </>
    ),
    link: '/locker',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="4" width="16" height="16" rx="2" />
        <circle cx="12" cy="11" r="2" />
        <path d="M12 13v3" />
        <path d="M10 8a2 2 0 0 1 4 0" />
      </svg>
    ),
  },
  {
    id: 4,
    name: (
      <>
        VR
        <br />
        Experiences
      </>
    ),
    link: '/vr-darshan',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 8h16a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-3l-2-2.5-2 2.5H4a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2z" />
        <circle cx="8" cy="13" r="1.5" />
        <circle cx="16" cy="13" r="1.5" />
        <path d="M2 13h2" />
        <path d="M20 13h2" />
        <path d="M12 4v4" />
        <path d="M8 5l2 3" />
        <path d="M16 5l-2 3" />
      </svg>
    ),
  },
  {
    id: 5,
    name: (
      <>
        Guides &
        <br />
        More
      </>
    ),
    link: '/listing',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
        <line x1="12" y1="7" x2="12" y2="13" />
        <line x1="9" y1="10" x2="15" y2="10" />
      </svg>
    ),
  },
];

export default function BlogListing() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [visibleBlogsCount, setVisibleBlogsCount] = useState(10);

  useEffect(() => {
    document.title = 'Blog - Stories, Rituals & Festivals | MandirWiki';
    window.scrollTo({ top: 0, behavior: 'smooth' });

    const updateHeaderHeight = () => {
      const headerEl = document.querySelector('.header') || document.querySelector('.mainHeader');
      if (headerEl) {
        const height = headerEl.getBoundingClientRect().height;
        if (height > 0) {
          document.documentElement.style.setProperty('--site-header-height', `${height}px`);
        }
      }
    };

    updateHeaderHeight();
    const rafId = requestAnimationFrame(updateHeaderHeight);
    window.addEventListener('resize', updateHeaderHeight);

    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener('resize', updateHeaderHeight);
    };
  }, []);

  const handlePrev = () => {
    setCurrentSlide((prev) => (prev - 1 + featuredStories.length) % featuredStories.length);
  };

  const handleNext = () => {
    setCurrentSlide((prev) => (prev + 1) % featuredStories.length);
  };

  const handleLoadMore = () => {
    setVisibleBlogsCount((prev) => prev + 10);
  };

  const activeStory = featuredStories[currentSlide];
  const displayedBlogs = allBlogsData.slice(0, visibleBlogsCount);

  return (
    <div className="blog-listing-page">
      {/* Featured Story Hero Banner */}
      <section
        className="blog-featured-banner"
        style={{
          backgroundImage: `url(${activeStory.image})`,
        }}
      >
        {/* Navigation Arrow - Left */}
        <button
          type="button"
          className="banner-nav-btn prev-btn"
          onClick={handlePrev}
          aria-label="Previous story"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ffffff"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>

        {/* Navigation Arrow - Right */}
        <button
          type="button"
          className="banner-nav-btn next-btn"
          onClick={handleNext}
          aria-label="Next story"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ffffff"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>

        <Container maxWidth="lg" className="banner-container">
          <Box className="banner-content" key={activeStory.id}>
            <span className="featured-tag">{activeStory.tag}</span>

            <h1 className="banner-title">
              {activeStory.title}
            </h1>

            <p className="banner-desc">
              {activeStory.desc}
            </p>

            <div className="banner-meta">
              <div className="meta-item">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#ffffff"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
                <span>{activeStory.readTime}</span>
              </div>

              <div className="meta-item">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#ffffff"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
                <span>{activeStory.views}</span>
              </div>
            </div>

            <Link to={activeStory.link} className="banner-btn">
              {activeStory.buttonText}
            </Link>
          </Box>
        </Container>

        {/* Bottom Carousel Indicators */}
        <div className="banner-indicators">
          {featuredStories.map((_, idx) => (
            <button
              key={idx}
              type="button"
              className={`indicator-dot ${idx === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(idx)}
              aria-label={`Slide ${idx + 1}`}
            />
          ))}
        </div>
      </section>

      {/* Explore by Category Section - Slider */}
      <section className="blog-category-section pb-0">
        <Container maxWidth="lg">
          <div className="category-section-header">
            <div className="header-left">
              <h2 className="section-title">Explore by Category</h2>
              <p className="section-subtitle">
                Find stories that inspire, inform and connect you to India’s sacred heritage.
              </p>
            </div>
            <div className="header-right">
              <a href="#all-blogs" className="view-all-btn">
                View All Blogs <span className="arrow">›</span>
              </a>
            </div>
          </div>

          <div className="category-slider-wrapper">
            {/* Left Floating Arrow */}
            <button
              type="button"
              className="cat-slider-arrow cat-prev-btn"
              aria-label="Previous categories"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </button>

            <Swiper
              modules={[Navigation]}
              navigation={{
                prevEl: '.cat-prev-btn',
                nextEl: '.cat-next-btn',
              }}
              slidesPerView={2.2}
              spaceBetween={12}
              breakpoints={{
                0: {
                  slidesPerView: 2.2,
                  spaceBetween: 12,
                },
                480: {
                  slidesPerView: 2.6,
                  spaceBetween: 14,
                },
                640: {
                  slidesPerView: 3.4,
                  spaceBetween: 14,
                },
                768: {
                  slidesPerView: 4.2,
                  spaceBetween: 16,
                },
                1024: {
                  slidesPerView: 5.2,
                  spaceBetween: 16,
                },
                1200: {
                  slidesPerView: 6,
                  spaceBetween: 18,
                },
              }}
              className="categories-swiper"
            >
              {categories.map((cat) => (
                <SwiperSlide key={cat.id}>
                  <a
                    href={cat.link}
                    className="category-card"
                    title={cat.title}
                  >
                    <div className="card-image-wrap">
                      <img
                        src={cat.image}
                        alt={cat.title}
                        loading="lazy"
                      />
                      <div className="card-overlay">
                        <h3 className="card-title">{cat.title}</h3>
                        <span className="card-articles">{cat.articles}</span>
                      </div>
                    </div>
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Right Floating Arrow */}
            <button
              type="button"
              className="cat-slider-arrow cat-next-btn"
              aria-label="Next categories"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
          </div>
        </Container>
      </section>

      {/* All Blogs Section */}
      <section id="all-blogs" className="blog-trending-section blog-all-blogs-section pb-0">
        <Container maxWidth="lg">
          <div className="trending-section-header">
            <div className="header-left">
              <h2 className="section-title">Trending Stories</h2>
              <p className="section-subtitle">
                Most read and loved by our community
              </p>
            </div>
          </div>

          <div className="trending-grid">
            {displayedBlogs.map((story) => (
              <Link
                to={story.link}
                className="trending-card"
                key={story.id}
                title={story.title}
              >
                <div className="card-img-wrap">
                  <img
                    src={story.image}
                    alt={story.title}
                    loading="lazy"
                  />
                  {story.badge && (
                    <span className="card-badge">{story.badge}</span>
                  )}
                </div>

                <div className="card-body">
                  <h3 className="card-title">{story.title}</h3>
                  <p className="card-desc">{story.desc}</p>

                  <div className="card-footer-meta">
                    <div className="meta-left">
                      <div className="meta-item">
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <circle cx="12" cy="12" r="10" />
                          <polyline points="12 6 12 12 16 14" />
                        </svg>
                        <span>{story.readTime}</span>
                      </div>

                      <div className="meta-item">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8z" />
                          <circle cx="12" cy="12" r="3" />
                        </svg>
                        <span>{story.views}</span>
                      </div>
                    </div>

                    <div className="meta-right">
                      <span className="bookmark-icon">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {allBlogsData.length > visibleBlogsCount && (
            <div className="load-more-wrap">
              <button
                type="button"
                className="load-more-btn"
                onClick={handleLoadMore}
              >
                Load More
              </button>
            </div>
          )}
        </Container>
      </section>

      {/* Stories You Probably Didn't Know Section */}
      <section className="blog-unknown-section pb-0">
        <Container maxWidth="lg">
          <div className="unknown-section-header">
            <div className="header-left">
              <h2 className="section-title">Stories You Probably Didn't Know</h2>
              <p className="section-subtitle">
                Fascinating facts, lesser-known stories and hidden truths from India's sacred places.
              </p>
            </div>
            <div className="header-right">
              <a href="#all-stories" className="view-all-btn">
                View All <span className="arrow">›</span>
              </a>
            </div>
          </div>

          <div className="unknown-grid">
            {unknownStories.map((story) => (
              <Link
                to={story.link}
                className="unknown-card"
                key={story.id}
                title={story.title}
              >
                <div className="card-img-wrap">
                  <img
                    src={story.image}
                    alt={story.title}
                    loading="lazy"
                  />
                </div>

                <div className="card-body">
                  <h3 className="card-title">{story.title}</h3>
                  <div className="card-footer-meta">
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                    <span>{story.readTime}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </Container>
      </section>

      {/* Turn Faith Into Journey CTA Banner Section */}
      <section className="blog-faith-section">
        <Container maxWidth="lg">
          <div className="blog-faith-banner">
            <div className="faith-banner-overlay" />
            <div className="faith-banner-inner">
              <div className="faith-banner-content">
                <h2 className="faith-banner-title">
                  Turn Your Faith Into a Journey
                </h2>
                <p className="faith-banner-desc">
                  Discover temples, plan your trip, book services and experience India's spiritual heritage like never before.
                </p>
                <Link to="/listing" className="faith-banner-btn">
                  Plan Your Pilgrimage <span className="btn-arrow">→</span>
                </Link>
              </div>

              <div className="faith-banner-services">
                {faithServices.map((service) => (
                  <Link
                    to={service.link}
                    key={service.id}
                    className="faith-service-item"
                  >
                    <div className="service-icon-circle">
                      {service.icon}
                    </div>
                    <span className="service-name">{service.name}</span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </Container>
      </section>
      <section></section>
    </div>
  );
}
